// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1ociX","disabled":"FileBtn_disabled__39aiX","warn":"FileBtn_warn__3Z0Wd","fade":"FileBtn_fade__2Kmhn"};